<template>
    <a-card>
        <div style="display: flex;justify-content: space-between;">
            <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
                <a-form-item label="填报年份" name="year">
                    <YearPicker style="width: 100%" v-model:value="searchForm.year" :format="dateFormat.DATE_YEAR"
                                :showTime="false"/>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="onSearch">查询</a-button>
                    <a-button @click="onReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="table-toolbar">
            <a-button type="primary" @click="openAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-table :columns="columns"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                 :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
<!--            <template #year="{ record }">-->
<!--                <a @click="onDetail(record)">{{ record.year }}</a>-->
<!--            </template>-->
            <template #isLoad="{record}">
                {{ record.isLoad == 0 ? '无' : '有' }}
            </template>
            <template #isDemand="{record}">
                {{ record.isDemand == 0 ? '无' : '有' }}
            </template>
            <template #action="{ record }">
                <div class="table-row-operations">
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <DetailModalInfo ref="detailModalInfo" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import DetailModalInfo from './components/DetailModalInfo.vue';
import DetailModal from './components/newUserModal';
import {tableListMixin, dictMixin} from "@/mixins";
import {sys_policy} from "@/api/policyService";
import {dateFormat} from "@/config/variableConfig";
import {message} from "ant-design-vue";
import {companyInfo, finance} from '@/api/companyService';
import {file_service} from "@/api/adminService";
import {sys_finance_demand} from "@/api/financeDemand";

const columns = [
    {title: "填报年份", dataIndex: "year", key: "year", slots: {customRender: "year"}},
    {title: "贷款情况", dataIndex: "isLoad", key: "isLoad", slots: {customRender: "isLoad"}},
    // {title: "贷款额度（万元）", dataIndex: "intentionAmount", key: "intentionAmount",},
    {title: "贷款需求", dataIndex: "isDemand", key: "isDemand", slots: {customRender: "isDemand"}},
    {title: "意向额度（万元）", dataIndex: "intentionAmount", key: "intentionAmount",},
    {title: "期望利率", dataIndex: "intentionRate", key: "intentionRate",},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin, dictMixin],
    components: {
        DetailModal,
        DetailModalInfo
    },
    data() {
        return {
            erweimaCode: '',
            dictNames: 'FundTrackingSubsidyType',
            dateFormat,
            noAdd: true,
            columns,
            yearArr: [],
            queryParam: {},
            listKeyField: "id",
            listUrl: sys_finance_demand.pageListWeb,
            deleteUrl: sys_finance_demand.remove
        }
    },
    mounted() {
        this.getDate(),
        this.getYearData()
        this.erweimaCode = this.$ls.get('erweimaCode')
    },
    methods: {
        openAdd() {
            if (this.noAdd) {
                let one = true;
                const year = new Date().getFullYear();
                this.getAction({
                    url: sys_finance_demand.pageListWeb,
                    params: {year: year,}
                }).then(res => {
                    if (res.total > 0) {
                        one = false;
                    }
                    if (one) {
                        this.onShowModal('detailModal', {id: null, enterpriseFinanceDemandLoadList: [], year: '2024'});
                    } else {
                        this.$notification.warning({
                            message: '一年只能填报一次',
                            style: {
                                fontWeight: '600',
                            },
                        });
                    }
                })
            } else {
                this.$notification.warning({
                    message: '不在填报时间内',
                    style: {
                        fontWeight: '600',
                    },
                });
            }
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        getYearData() {
            this.postAction({
                url: sys_policy.getYearData,
                params: {cashingTypeValue: '3',}
            }).then(res => {
                let arr = []
                res.map(item => {
                    arr.push({label: item + '年', value: item + ''})
                })
                this.yearArr = arr
            })
        },
        onAdd() {
            if (this.yearArr.length > 0) {
                this.getAction({
                    url: companyInfo.detail
                }).then(res => {
                    if (res.companyName && res.oraganizationCode && res.detailedAddress && res.corporation) {
                        this.getAction({
                            url: finance.detail,
                            params: {
                                companyCode: this.$ls.get("companyCode")
                            }
                        }).then(aa => {
                            if (aa.bankName && aa.bankAccount && aa.bankCode) {
                                let obj = {
                                    isEdit: true,
                                    year: this.yearArr.length == 1 ? this.yearArr[0].value : undefined,
                                    yearArr: this.yearArr,
                                    companyName: res.companyName,
                                    oraganizationCode: res.oraganizationCode,
                                    detailedAddress: res.detailedAddress,
                                    openingBank: aa.bankName,
                                    accountNumber: aa.bankAccount,
                                    bankPermitFile: aa.bankPermitFile,
                                    lineNumber: aa.bankCode,
                                    subsidySVos: []
                                }
                                this.onShowModal('userModal', obj);
                            } else {
                                message.warning('请完善档案管理财务信息！')
                                this.$router.push({path: '/sys/finance'})
                            }
                        })
                    } else {
                        message.warning('请完善企业基本信息！')
                        this.$router.push({path: '/sys/companyInfo'})
                    }
                })
            } else {
                message.warning('该政策兑现未开启！')
            }
        }, getDate() {
            this.getAction({
                url: sys_finance_demand.getDate,
                // params: { id: id },
                returnMsg: true,
            }).then((res) => {
                if (res.data.etype == '1') {
                    this.noAdd = false
                }
                // this.getDateId = res.data.id

            });
        },
        onEdit(record) {
            if (record.intentionRate) {
                record.intentionRate = String(record.intentionRate)
            }
            if (record.intentionAmount) {
                record.intentionAmount = String(record.intentionAmount)
            }
            if (record.intentionBank) {
                if (record.intentionBank.includes('7')) {
                    this.$refs['detailModal'].otherType = false
                } else {
                    this.$refs['detailModal'].otherType = true
                }
            }
            if (record.enterpriseFinanceDemandLoadList) {
                record.enterpriseFinanceDemandLoadList.forEach(item => {
                    if (item.loadBankname) {
                        item.otherType1 = false
                    } else {
                        item.otherType1 = true
                    }
                })
            }
            this.onShowModal('detailModal', record)
        },
        onDetail(record) {
            this.getAction({
                url: sys_finance_demand.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('detailModalInfo', res);
            })
        },
    }
}
</script>
<style scoped lang="less">
:deep(.ant-popover-inner-content) {
    width: 240px;
}
</style>
